import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import styles from './super-user-bar.css'

const SuperUserBar = ({ portalUser, portalSuperuser }) => (
  <div styleName="super-user-bar">
    You are acting as the portal user: {portalUser.firstName} {portalUser.lastName} ({portalUser.email}) -
    <a href={`/superuser_choose_user?user_id=${portalSuperuser.id}`} styleName="exit"> Exit</a>
  </div>
)

SuperUserBar.propTypes = {
  portalSuperuser: PropTypes.object,
  portalUser: PropTypes.object,
}


export default CSSModules(SuperUserBar, styles)




/** WEBPACK FOOTER **
 ** ./src/components/super-user-bar/super-user-bar.js
 **/